// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"13badad4","484":"13badad4"}[chunkId] + ".chunk.css";
};